<template>
    <div>
     <v-col >
        <v-card
          class="full-height v-card-padding d-flex flex-column"
          color="#FFFFFF00"
          elevation="0"
        >
          <v-list
            style="max-height: 370px;     min-width: 300px; "
            class="overflow-y-auto"
            color="#FFFFFF00"
          >
            <v-list-item-group class="p-0 m-0 "  >
              <v-list-item
              :class = "item1.active"
                class="p-0 m-0 "
                v-for="(item1, i) in item1"
                :key="i"
                @click="click_checkbox(i)"
              >
          <!--      <v-list-item-icon :class="item1.iconText+'father'">
                  <v-icon color="#000000" v-text="item1.iconText"></v-icon>
                </v-list-item-icon> -->
                <div class="icon_element">
                  <div :class="select_circle">
                  </div>
                </div>
                <v-list-item-content>
                  <v-list-item-title
                    class="title-download-button"
                    v-text="item1.title"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    class="subtitle-download-button"
                    v-text="item1.subtitle"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </div>
</template>
<script>
export default {
  name: "checkboxcomponent",
  props: ['item1'],
  data() {
    return {
      test: "test",
     select_circle : 'select_circle'
    };
  },
  mounted() {
try{
    if (document.body.classList.contains('single-product')){
      let c = document.getElementById('sezione_dowload_prodotto');
      c.classList.remove('sezione_download_nonmostrare');
    }
  }catch(e){
                console.info(e)
            }
  },
  methods: {
      click_checkbox(i){
        if (this.select_circle == 'select_circle') {
          this.select_circle = 'selected_circle';
        }else{
          this.select_circle = 'select_circle';
        }
        try{
              this.item1.forEach((element, j) => {
        if (i === j) {
          if (element.iconText == "mdi-circle-outline") {
            element.iconText = "mdi-radiobox-marked";
            element.selected = true;
          } else {
            element.iconText = "mdi-circle-outline";
            element.selected = false;
          }
        }

        // DO SOMETHING ITEM 1

        // TO HERE
      });
           } catch (error) {
            console.info(error);
        }
      }
  }
}
</script>

<style scoped>
@media only screen  and (max-width: 1100px){
.v-card-padding
{
  padding-top:0px !important;
  padding-bottom:0px !important;
}
.v-card-padding * {
  padding-top:0 !important;
  padding-bottom:0px !important;
}

}
@media only screen  and (min-width: 1100px){
.v-card-padding
{
  padding-top:20px !important;
  padding-bottom:20px !important;
}
}
.v-card-padding
{
 max-width: 250px !important;
 }
.title-download {
  padding-top: 35px;
  padding-left: 60px;
  color: #000000;
  font-size: 38px;
  font-weight: 550;
}
.subtitle-download {
  padding-top: 0px;
  padding-left: 60px;
  padding-bottom: 0px;
  color: #000000;
  font-size: 18px;
  font-weight: 500;
}
.title-download-button {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 1.75rem;
  letter-spacing: 0.009375em !important;
  font-weight: 700;
  padding-top: 5px;
  scroll-padding-bottom: 3px;
  font-family: "Montserrat";
}
.subtitle-download-button {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.03125em !important;
  padding-top: 8px;
  font-family: "Montserrat";
}

.button-download-main {
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em !important;
  font-family: "Montserrat";
  font-weight: 600;
  border-color: black;
  color: #000000;
}

.v-list-item--active::before,
.v-list-item:focus::before {
  opacity: 0 !important;
}

/* ADJUST HEIGHT WIDTH AND PADDING OF THE ENTIRE BLOCK DOWNLOAD  */
.brownClass {
  background: #c5c4c1;
  margin-top: 5% !important;
  max-width: 92% !important;
}

#download_wrapper #app {
  background: #c5c4c1 !important;

  max-width: 100% !important;
}
.disabled{
    pointer-events: none !important;
    opacity:0.5;
}
.select_circle {
  background: url("../../../src/assets/svg/select.svg");
  border: 0px solid  rgba(116, 33, 33, 0) !important;
   background-repeat: no-repeat;
   width:26px !important;
   height:26px !important;
       margin-right: 20px;
}
.selected_circle{
  background: url("../../../src/assets/svg/select_selected.svg");
  border: 0px solid  rgba(116, 33, 33, 0) !important;
  background-repeat: no-repeat;
    width:26px !important;
   height:26px !important;
       margin-right: 20px;
}
.v-list-item--link.theme--light{
  align-items: baseline;
}
</style>